import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
Vue.use(VueRouter);
var originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

var baseTitle = '河南悟能网络科技有限公司';
var router = new VueRouter({
  routes: routes
});
router.beforeEach(function (to, from, next) {
  next();
});
router.afterEach(function (to, from) {
  var _to$meta;

  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0; // firefox

  var res = (_to$meta = to.meta) !== null && _to$meta !== void 0 && _to$meta.webTitle ? to.meta.webTitle + ' - ' : '';
  document.title = res + baseTitle;
});
export default router;